// Chromium limits individual BufferSource Blob parts to 2 GiB. Keep parts
// comfortably below that limit without copying the backing byte array.
export const blobParts = (bytes: Uint8Array, chunkSize = 64 * 1024 * 1024): BlobPart[] => {
    if (!Number.isSafeInteger(chunkSize) || chunkSize <= 0 || chunkSize > 1024 * 1024 * 1024) throw new Error('Invalid Blob chunk size.');
    const parts: BlobPart[] = [];
    for (let offset = 0; offset < bytes.byteLength; offset += chunkSize) {
        parts.push(bytes.subarray(offset, Math.min(offset + chunkSize, bytes.byteLength)) as BlobPart);
    }
    return parts;
};
